import { FC, Dispatch, SetStateAction, useEffect } from 'react'
import {
  FormContainer,
} from 'src/components/application/defaultComponents'
import NewItemForm from './NewItemForm'
import Button from 'src/components/basic/Button'
import { AttorneyData } from 'src/dtos/applicationData'
import { RenewVerifyItemForm } from './RenewVerifyItemForm'

const newAttorneyData = {
  firstName: '',
  lastName: '',
}

interface Props {
  attorneys: AttorneyData[];
  setAttorneys: Dispatch<SetStateAction<AttorneyData[]>>;
  handleSaveDetails: () => Promise<void>;
  showErrors?: boolean;
  disableAddNewAttorneys?: boolean;
  allAccordionsOpen?: boolean;
  isRenewal?: boolean;
  setDisableSaveandContinue: Dispatch<SetStateAction<boolean>>;
  isAttorneyVerification : boolean;
  errorCodes?: string[];
}

const NewAttorneysForm: FC<Props> = ({
  attorneys,
  setAttorneys,
  handleSaveDetails,
  showErrors,
  disableAddNewAttorneys,
  allAccordionsOpen,
  isRenewal,
  setDisableSaveandContinue,
  isAttorneyVerification,
  errorCodes = [],
}) => {
  const handleAttorneyChange = (attorneyIndex: number, changes: Partial<AttorneyData>) => {
    let attorneyCopy: {[prop: string]: any} = { ...attorneys[attorneyIndex] }

    attorneyCopy = { ...attorneyCopy, ...changes }

    setAttorneys(prev => [...prev.map((attorney, idx) => idx === attorneyIndex ? attorneyCopy : attorney)])
  }

  const handleRemoveAttorney = (index: number) => {
    setDisableSaveandContinue(false)
    setAttorneys(prev => prev.filter((p, idx) => idx !== index))
  }

useEffect(()=>{

  const isEmpty = attorneys.every(attorney => {
    return (!attorney.firstName || attorney.firstName.trim() === '') && (!attorney.lastName || attorney.lastName.trim() === '');
  });

  if(isEmpty){
    setDisableSaveandContinue(true)
  }
},[attorneys, setDisableSaveandContinue])

const handleSetAttorney = () => {
  setDisableSaveandContinue(true)
  setAttorneys(prev => ([...prev, newAttorneyData]))
}

  return (
    <FormContainer maxWidth='624px'>
      {attorneys.map((attorney, index) => (
        !isAttorneyVerification && !isRenewal ? (
          <NewItemForm
            key={index}
            attorney={attorney}
            handleSaveDetails={handleSaveDetails}
            setAttorney={(changes) => handleAttorneyChange(index, changes)}
            removeAttorney={() => handleRemoveAttorney(index)}
            attorneyNumber={index}
            showErrors={showErrors}
            allAccordionsOpen={allAccordionsOpen}
            disableAddNewAttorneys={disableAddNewAttorneys}
            errorCodes={errorCodes?.map(e => `${e}:${index}`)!}
          />

        ) : (
          <RenewVerifyItemForm
            key={index}
            attorney={attorney}
            setAttorney={(changes) => handleAttorneyChange(index, changes)}
            attorneyNumber={index}
            isIncorrect={showErrors}
            errorCodes={errorCodes?.map(e => `${e}:${index}`)!}
          />
        )
      ))}
      {disableAddNewAttorneys === true ? null : (
        <Button
          variant="secondary"
          onClick={() => handleSetAttorney()}
          style={{ marginTop: '60px', maxWidth: '360px' }}
        >
          Add another attorney
        </Button>
      )}
    </FormContainer>
  )
}

export default NewAttorneysForm